"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupScoring = void 0;
var GroupScoring;
(function (GroupScoring) {
    GroupScoring["COHORT"] = "Cohort";
    GroupScoring["CONTINUOUS_VARIABLE"] = "Continuous Variable";
    GroupScoring["PROPORTION"] = "Proportion";
    GroupScoring["RATIO"] = "Ratio";
})(GroupScoring = exports.GroupScoring || (exports.GroupScoring = {}));
